import styled, { css } from 'styled-components';
import { Button, Col } from 'antd';
import { Risk } from '@/components/views/Resolution886/enums';

export const Container = styled(Col)`
	.ant-skeleton {
		width: 100%;

		.ant-skeleton-button {
			width: 100%;
			height: 60px;
			border-radius: ${({ theme }) => theme.border.border_radius.br_xl};
		}
	}
`;

export const CategoryButton = styled(Button)`
	width: 100%;
	height: auto;
	display: flex;
	padding: 16px 20px;
	align-items: center;
	justify-content: space-between;
	border-radius: ${({ theme }) => theme.border.border_radius.br_xl};

	p {
		${({ theme }) => css`
			${{ ...theme.fonts.label.md }}
		`}
		margin: 0;
		font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	}
`;

export const StatusContent = styled.div<{ risk?: Risk }>`
	background-color: ${({ theme, risk }) =>
		risk === Risk.TOLERABLE
			? theme.colors.risk.low
			: risk === Risk.MODERATE
			? theme.colors.risk.medium
			: risk === Risk.NOT_TOLERABLE
			? theme.colors.risk.high
			: theme.palette.secondary[100]};

	border-radius: 4px;
	height: 32px;
	padding: 4px 8px;
	width: fit-content;

	p {
		color: ${({ theme, risk }) => (risk ? theme.palette.secondary.white : theme.colors.text)} !important;
		font-size: 14px !important;
		font-weight: ${({ theme, risk }) =>
			risk ? theme.sizes.weights.semibold : theme.sizes.weights.regular} !important;
		margin: 0 !important;
	}
`;
